import { showToast } from '@inscribe/signal';
import { PROCESSED } from '../constants/documentStates';

export function showDuplicateUploadToast(duplicates) {
  let title, text;
  const filenames = duplicates.map((dup) => `"${dup.filename}"`);

  if (filenames.length === 0) {
    return;
  }

  if (duplicates.length === 1) {
    title = 'Duplicate document rejected';
    text = `The file "${duplicates[0].filename}" is a duplicate of an existing document and has been rejected.`;
  } else {
    const lastFilename = filenames.pop();
    title = 'Duplicate documents rejected';
    text = `The files ${filenames.join(', ')} and ${lastFilename} are duplicates of existing documents and have been rejected.`;
  }

  showToast({ title: title, text: text, isError: true });
}

export const showDocumentProcessedNotification = (
  documentName,
  url,
  state = PROCESSED,
) => {
  if (notificationsSupported && notificationPermissionsIsGranted()) {
    const title =
      state === PROCESSED
        ? `"${documentName}" has finished processing`
        : `Error processing ${documentName}`;

    const notification = new Notification(title, {
      icon: 'https://local.inscribe.ai/favicon.ico',
    });
    notification.onclick = function () {
      window.parent.focus();
      window.document.location = url;
      notification.close();
    };
  } else if (notificationsSupported) {
    Notification.requestPermission().then((response) => {
      if (response === 'granted') {
        showDocumentProcessedNotification(documentName, url, state);
      }
    });
  }
};

export const notificationsSupported = typeof Notification !== 'undefined';

export const notificationPermissionsIsGranted = () =>
  notificationsSupported && Notification.permission === 'granted';
